module.exports = __webpack_public_path__ + "static/media/zim@3x.ddc5774d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/flags/zim@3x.png
// module id = 126
// module chunks = 0